import { LmgService } from "../resource";

// TransactionV2 — parallel module for the /lmg/v2/transaction page.
// Mirrors lmg_trans_module.js so V2 can evolve without touching V1.
const TransV2Module = {
  namespaced: true,
  state: {
    datas: [],
    cancel: [],
    whts: [],
    data: {},
    isLoading: false,
    // Monotonic counters — every list* call bumps its counter; late responses
    // whose seq != the current counter are dropped so stale results from
    // a slow first query can't overwrite fresh results from a later query.
    _listDataSeq: 0,
    _listWhtSeq: 0,
    _listCancelSeq: 0,
  },
  mutations: {
    SET_CANCEL(state, payload) {
      state.cancel = payload;
    },
    SET_WHTS(state, payload) {
      state.whts = payload;
    },
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
    PATCH_ROW(state, { id, fields }) {
      // Optimistic in-place row patch for inline quick-edit.
      const idx = state.datas.findIndex(r => r.ID === id || r.id === id);
      if (idx >= 0) {
        state.datas.splice(idx, 1, { ...state.datas[idx], ...fields });
      }
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.TransactionCreate(payload);
    },
    cancelData({ commit, state }, payload) {
      return LmgService.TransactionCancel(payload);
    },
    updatePolicyNumber({ commit, state }, payload) {
      return LmgService.TransactionUpdatePolicyNumber(payload.ID, payload);
    },
    updateDate({ commit, state }, payload) {
      return LmgService.TransactionUpdateDate(payload.ID, payload);
    },
    async listData({ commit, state }, payload) {
      state._listDataSeq += 1;
      const mySeq = state._listDataSeq;
      state.isLoading = true;
      try {
        const resp = await LmgService.TransactionList(payload);
        if (mySeq !== state._listDataSeq) return;
        commit("SET_DATAS", resp.data.Data == null ? [] : resp.data.Data);
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listDataSeq) return;
        commit("SET_DATAS", []);
        state.isLoading = false;
      }
    },

    async listWht({ commit, state }, payload) {
      state._listWhtSeq += 1;
      const mySeq = state._listWhtSeq;
      state.isLoading = true;
      commit("SET_WHTS", []);
      try {
        const resp = await LmgService.WhtList(payload);
        if (mySeq !== state._listWhtSeq) return;
        commit("SET_WHTS", resp.data.Data == null ? [] : resp.data.Data);
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listWhtSeq) return;
        console.log(err);
        state.isLoading = false;
      }
    },

    async listCancel({ commit, state }, payload) {
      state._listCancelSeq += 1;
      const mySeq = state._listCancelSeq;
      state.isLoading = true;
      commit("SET_CANCEL", []);
      try {
        const resp = await LmgService.TransactionCancelList(payload);
        if (mySeq !== state._listCancelSeq) return;
        commit("SET_CANCEL", resp.data.Data == null ? [] : resp.data.Data);
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listCancelSeq) return;
        console.log(err);
        state.isLoading = false;
      }
    },

    clearTrans({ commit }) {
      commit("SET_DATAS", []);
    },

    ReportDiscount({ commit, state }, payload) {
      return LmgService.ReportDiscount(payload);
    },
    ReportTaxDiscount({ commit, state }, payload) {
      return LmgService.ReportTaxDiscount(payload);
    },
    CalCommision({ commit, state }, payload) {
      return LmgService.TransactionCalCommision(payload);
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getWht(state) {
      return state.whts;
    },
    getCancel(state) {
      return state.cancel;
    },
    isLoading(state) {
      return state.isLoading;
    },
  },
};

export default TransV2Module;
